module.exports = __webpack_public_path__ + "img/Pic_LOGO_XYZQ.33864935.png";